import { useKeyboardControls } from "@react-three/drei";

export default function Keyboard() {
    {/* ------------------------- Keyboard Highlights key ------------------------ */ }
    const forward = useKeyboardControls((state) => state.forward)
    const backward = useKeyboardControls((state) => state.backward)
    const leftward = useKeyboardControls((state) => state.leftward)
    const rightward = useKeyboardControls((state) => state.rightward)
    {/* ------------------------- Fin Keyboard Highlights key ------------------------ */ }



    return <div className="controls">
        <div className="raw">
            <div className={`key ${forward ? 'active' : ''}`}>Z</div>
        </div>
        <div className="raw">
            <div className={`key ${leftward ? 'active' : ''}`}>Q</div>
            <div className={`key ${backward ? 'active' : ''}`}>S</div>
            <div className={`key ${rightward ? 'active' : ''}`}>D</div>
        </div>
    </div>

}